import React, { useState, useEffect } from 'react';
import { Modal, Container, List, Grid, Input, Button, Icon } from 'semantic-ui-react';
import {getCompanyDocument} from '../../../firebase';

const EditarAlmacenes = ({ onModalSubmit, almacenes }) => {
    const [newAlmacen, setNewAlmacen] = useState('');
    const [almacenesNew, setAlmacenes] = useState(almacenes);
    const [openModal, setOpenModal] = useState(false);
    const [boton, setBoton] = useState(true);
  
    useEffect(() => {
      const isButtonDisabled = !(almacenesNew);
      setBoton(isButtonDisabled);
    }, [almacenesNew]);
    
    const handleSave = async () => {
      const company = await getCompanyDocument()
      await company.update({
        almacenes: almacenesNew,
      })
      setOpenModal(false)
      setNewAlmacen('')
      onModalSubmit()
      alert("Datos Guardados")
    }
    const removeAlmacen =(index)=>{
      const newValues = [...almacenesNew];
      newValues.splice(index, 1);
      setAlmacenes(newValues)
    }
    const addAlmacen =()=>{
      const newValues = [...almacenesNew];
      newValues.push(newAlmacen)
      setAlmacenes(newValues)
      setNewAlmacen('')
    }
  
    return (
      <label>
      <button className='editar' onClick={()=>setOpenModal(true)}>
        <Icon name='edit' />
      </button>
      <Modal 
        open={openModal}
        onOpen={()=>setOpenModal(true)}
        onClose={()=>setOpenModal(false)}
      >
        <Modal.Header>
          <Container textAlign="center">
            Cambiar lista de almacenes
          </Container>
        </Modal.Header>
        <Modal.Content>
          <Grid columns={2} divided >
            <Grid.Row>
              <Grid.Column>
                  <Container textAlign='right'><p>Almacenes:</p></Container>
              </Grid.Column>
              <Grid.Column>
                <Container textAlign='left'>
                  <Input 
                    placeholder='Nuevo Almacen'
                    value = {newAlmacen}
                    onChange={(e) => setNewAlmacen(e.target.value)} 
                    required
                  />
                  <button className='agregar' 
                    onClick={()=>addAlmacen()}>
                    <Icon name='add circle' />
                  </button>
                  <List>
                    {
                    almacenesNew.map((item, index) => (
                      <List.Item key={index}>
                        <div className='list'>{item}</div>
                        <button 
                          className='borrar'
                          onClick={()=>removeAlmacen(index)}>
                          <Icon name='trash alternate' />
                        </button>
                      </List.Item>
                    ))
                    }
                  </List>
                </Container>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={()=>handleSave()} disabled={boton}>Enviar</Button>
        </Modal.Actions>
      </Modal>
      </label>
    );
  };

  export default EditarAlmacenes;
